/* eslint-disable eqeqeq */
import _ from 'lodash'
import { soapPost } from '../../ajaxSoap'
import { bizTypeMap } from '../../bizTypeMapping'
import {userInfo, $notify } from '../../../global'
import { i18n } from '../../i18n'
import { MasterPropertyType, InboundTypeValue, LotAttrCodeEnum } from '../bizEnum'
import { $Vue2Storage, StorageEnum } from '../../utils/storage/sessionStorage'
import { formatDate } from '../../utils/date'
import { MessageBox } from 'element-ui';
import { customizeNotifyWithVoiceFormat, NOTIFY_TYPE_ENUM } from '@/api/utils/message.js'
import router from '@/router'
const userInfoObj={
  orgNo: userInfo.orgNo,
  distributeNo: userInfo.distributeNo,
  warehouseNo: userInfo.warehouseNo
}
// 获取SKU
export const getGoods = async (goodsNo,ownerNo) => {
  let goods;
  // let goods = $Vue2Storage.get(StorageEnum.Goods, goodsNo)
  // if (goods && !_.isEmpty(goods)) { // 缓存中没有当前sku，需要从master取，然后添加到缓存
  //   console.log('goods:' + JSON.stringify(goods))
  //   return goods
  // }
  await soapPost(bizTypeMap.wms_masterservice_scanGoodsInfoByCode, {
    'code': goodsNo,
    'colNames': MasterPropertyType.getAllProperty,
    'needExtAttr': '1',
    'ownerNo': ownerNo || '',
  }).done(function (data) {
    goods = data
  })
  $Vue2Storage.set(StorageEnum.Goods, goodsNo, goods)
  return goods
}

// 箱零混拣
export const scanByCode = async (scanCode,ownerNo) => {
  let goods;
  // let goods = $Vue2Storage.get(StorageEnum.Goods, scanCode)
  // if (goods && !_.isEmpty(goods)) {
  //   // 缓存中没有当前sku，需要从master取，然后添加到缓存
  //   console.log('goods:' + JSON.stringify(goods))
  //   return goods
  // }
  await soapPost(bizTypeMap.scanByCode, {
    'code': scanCode,
    'colNames': MasterPropertyType.getAllProperty,
    'needExtAttr': '1',
    'ownerNo': ownerNo || '',
  }).done(function (data) {
    goods = data
  })
  $Vue2Storage.set(StorageEnum.Goods, scanCode, goods)
  return goods
}

// 自定义新增更新
export const insertCustomConditionsConfig = async (param) => {
  let ret
  await soapPost(bizTypeMap.insertCustomConditionsConfig,param).done(function (data) {
    ret = data
  })
  return ret
}

// 自定义配置查询区域查询
export const queryCustomConditionsConfigList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryCustomConditionsConfigList,param).done(function (data) {
    ret = data
  })
  return ret
}

// 获取供应商
export const qrySuppilerByNo = async (suppilerNo) => {
  let suppiler = $Vue2Storage.get(StorageEnum.Suppiler, suppilerNo)
  if (suppiler) { // 缓存中没有当前sku，需要从master取，然后添加到缓存
    return suppiler
  }
  await soapPost(bizTypeMap.wms_masterservice_qrySuppilerByNoForObj, { 'suppilerNo': suppilerNo })
    .done(function (data) {
      suppiler = data
    })
  $Vue2Storage.set(StorageEnum.Suppiler, suppilerNo, suppiler)
  return suppiler
}

export const getSysConfigByKey = async (key) => {
  // 'Attribute_Collection
  let isAttributeCollection = $Vue2Storage.get(StorageEnum.SysConfig, key)
  await soapPost(bizTypeMap.wms_masterservice_getSysConfigValue, {
    'key': key
  },{ noParseJson: true }).done(function (data) {
    isAttributeCollection = data
  })
  $Vue2Storage.set(StorageEnum.SysConfig, key, isAttributeCollection)
  return isAttributeCollection
}

/// 获取商品批属性，设置批属性是否需要采集
/// </summary>
/// <returns></returns>
export const createLotAttrList = async (task, taskD, inboundType) => {
  // 商品所有批属性
  let lotAttrList = []
  await soapPost(bizTypeMap.wms_masterservice_getLotAttrListOfSku, {
    'skuId': taskD.goodsNo
  }).done(function (data) {
    console.log('data', data);
    lotAttrList = data.lotAttrList
  })
  if (!lotAttrList || lotAttrList.length == 0) {
    $notify.error(i18n.t('getMasterGoodsLotError', [taskD.goodsNo]))
  }

  var lotAttrDTO = {}
  lotAttrDTO.sku = taskD.goodsNo
  lotAttrDTO.skuName = taskD.goodsName

  // lotAttrList.forEach(p =>
  for (let i = 0; i < lotAttrList.length; i++) {
    var p = lotAttrList[i]
    //批次管理的商品it17,it18要和it01一致
    if (inboundType == InboundTypeValue.Normal || inboundType == InboundTypeValue.AfterSales || inboundType == InboundTypeValue.RmSales || inboundType == InboundTypeValue.MoveWms || inboundType == InboundTypeValue.RejectWms) {
      if (p.attrCode == LotAttrCodeEnum.IsPo.code) {
        p.visible = false
        p.enable = false
        p.attrValue = task.ibReceivingTaskM.inboundNo
      } else if (p.attrCode == LotAttrCodeEnum.IsSupplier.code) {
        p.visible = false
        p.enable = false
        p.attrValue = task.ibReceivingTaskM.supplierNo
      } else if (p.attrCode == LotAttrCodeEnum.IsPLU.code) {
        p.visible = false
        p.enable = false
        p.attrValue = this.modal.txtGoodsNo
      } else if (p.attrCode == LotAttrCodeEnum.IsRcvDate.code) {
        p.visible = false
        p.enable = false
        p.attrValue = formatDate()
      } else if (p.attrCode == LotAttrCodeEnum.ProductionDate.code ||
                            p.attrCode == LotAttrCodeEnum.ExpirationDate.code) {
        p.visible = true
        p.enable = true
        lotAttrDTO.lifeType = taskD.lifeType
        lotAttrDTO.returnShelfLife = taskD.returnShelfLife
      } else if (p.attrCode == LotAttrCodeEnum.ReceivingDateLot.code) {
        p.visible = false
        p.enable = false
        p.attrValue = formatDate()
      } else if (p.attrCode == LotAttrCodeEnum.IsPackageBatch.code) {
        p.visible = true
        p.enable = true
      } else {
        p.visible = true
        p.enable = true
      }
    } else { // 备件库入大库单据 所有属性都需要录入
      p.visible = true
      p.enable = true
      if (p.attrCode == LotAttrCodeEnum.ProductionDate.code ||
                            p.attrCode == LotAttrCodeEnum.ExpirationDate.code) {
        lotAttrDTO.lifeType = taskD.lifeType
        lotAttrDTO.returnShelfLife = taskD.returnShelfLife
      }
      if (p.attrCode == LotAttrCodeEnum.ReceivingDateLot.code) {
        p.visible = false
        p.enable = false
        p.attrValue = formatDate()
      }
    }
  }
  lotAttrDTO.lotAttrList = lotAttrList
  return lotAttrDTO
}

export const scanGoodsInfoByCode4 = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_scanGoodsInfoByCode4,param).done(function (data) {
    ret = data
  })
  return ret
}

export const scanConsumableItem = async (param) => {
  let ret
  Object.assign(param,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo
  })
  await soapPost(bizTypeMap.wms_masterservice_scanConsumableItem,param).done(function (data) {
    ret = data
  })
  return ret
}

export const measureConsumableItem = async (param) => {
  let ret
  Object.assign(param,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    updateUser: userInfo.userCode,
  })
  await soapPost(bizTypeMap.wms_masterservice_measureConsumableItem,param).done(function (data) {
    ret = data
  })
  return ret
}


export const getSerialTracList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_getSerialTracList,param).done(function (data) {
    ret = data
  })
  return ret
}
export const querySerialTracDetailByOrderNo = async (param) => {
  let ret
  let config = {
    withoutWarehouse : true
  }
  await soapPost(bizTypeMap.wms_masterservice_querySerialTracDetailByOrderNo,param,config).done(function (data) {
    ret = data
  })
  return ret
}
export const querySerialTracDetailLikeOrderNo = async (param) => {
  let ret
  let config = {
    withoutWarehouse : true
  }
  await soapPost(bizTypeMap.wms_masterservice_querySerialTracDetailLikeOrderNo,param,config).done(function (data) {
    ret = data
  })
  return ret
}
// 逆向验证序列号一致性
export const getSerialTracListByCondition = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_getSerialTracListByCondition,param).done(function (data) {
    ret = data
  })
  return ret
}

export const qryItemBaseForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_qryItemBaseForList,param).done(function (data) {
    ret = data
  })
  return ret
}
// 扫码 pre-complete
export const scPreComplete = async (param) => {
  console.log('param', param)
  let ret
  await soapPost(bizTypeMap.sc_pre_complete,param).done(function (data) {
    console.log('data111',data)
    ret = data
  })

  return ret
}

export const getGoodsZoneRefInfoByGoodsNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_getGoodsZoneRefInfoByGoodsNo,param).done(function (data) {
    ret = data
  })
  return ret
}

export const getGoodName = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_qryItemBaseForObjToAOS,param).done(function (data) {
    ret = data
  })
  return ret
}

export const qryItemBaseForObj = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_qryItemBaseForObj,param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryBoxRuleListWithBoxBarcode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryBoxRuleListWithBoxBarcode,param).done(function (data) {
    ret = data
  })
  return ret
}

export const updateSkuBoxRule = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_updateSkuBoxRule,param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryGoodsType = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_saveOrUpdateItemBaseUnit,param,{ noParseJson: true,noShowError:true }).done(function (data) {
    ret = data
  })
  return ret
}

export const queryDicDetailList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryDicDetailList, newcrete, { noParseJson: false, withoutWarehouse: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

export const queryDicDetailAndConfigList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryDicDetailAndConfigList, newcrete, { noParseJson: false })
    .done(function (data) {
      ret = data
    })
  return ret
}


export const queryItemBaseReport = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryItemBaseReport,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const goodsInfoQueryByObject = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_pullGoodsInfoFromOMC,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const notifyToSendDownGoodsInfo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_mamasterservice_notifyToSendDownGoodsInfo,param).done(function (data) {
    ret = data
  })
  return ret
}


export const checkSerialIsMatchRules = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_batchCheckSerialIsRightByAllRules,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 校验单个序列号
export const checkSingleSerialIsMatchRules = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_checkSerialIsRightByAllRules,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const fmodifySerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_modifySerial,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 序列号 保存前判断
export const querySerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_querySerial,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
export const fdeleteSerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_deleteSerial,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
export const lockSingleSerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.lockSingleSerial,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
export const unlockeSingleSerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.unlockeSingleSerial,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
export const lockBatchSerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.lockBatchSerial, param).done(function (data) {
    ret = data
  })
  return ret
}
export const unlockBatchSerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.unlockBatchSerial,param).done(function (data) {
    ret = data
  })
  return ret
}
export const querySerialByBoxNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.querySerialByBoxNo,param).done(function (data) {
    ret = data
  })
  return ret
}

export const querySerialGoodsByBoxNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.querySerialGoodsByBoxNo,param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryMaxContainerCodeForEachType = async (param) => {
  var ret = null
  await soapPost(bizTypeMap.max_container_code_for_each_type, param,{ noParseJson: true })
    .done(function (data) {
      ret = data
    })
  return ret
}

// SAAS-保存开仓配置
export const submitWarehouseConfig = async (param) => {
  let ret
  await soapPost(bizTypeMap.submitWarehouseConfig,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-新增大区
export const addArea = async (param) => {
  let ret
  await soapPost(bizTypeMap.addArea,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// SAAS-新增大区
export const updateArea = async (param) => {
  let ret
  await soapPost(bizTypeMap.updateArea,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-删除大区
export const deleteArea = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteArea,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-查询大区列表
export const qryAreaForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.qryAreaForList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-查询大区列表 根据编号和名称查询
export const qryAreaByNoNameForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.qryAreaByNoNameForList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-新增大区
export const addZone = async (param) => {
  let ret
  await soapPost(bizTypeMap.addZone,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-删除大区
export const deleteZone = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteZone,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// saas更改储位名字
export const updateZone = async (param) => {
  let ret
  await soapPost(bizTypeMap.updateZone,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const queryZonePlanList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryZonePlanList,param).done(function (data) {
    ret = data
  })
  return ret
}

// 符合台信息维护按钮
export const updateEquipmentById = async (param) => {
  let ret
  await soapPost(bizTypeMap.updateEquipmentById,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

  // SAAS-查询大区列表
export const qryZoneForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.qryZoneForList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//新建字典主表数据
export const addDiccataLog = async (param) => {
  let ret
  await soapPost(bizTypeMap.addDiccataLog,param,{ noParseJson: true, formatData:true}).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-新增复核台 打包台
export const addEquipment = async (param) => {
  let ret
  await soapPost(bizTypeMap.addEquipment,param,{ noParseJson: true, formatData:true}).done(function (data) {
    ret = data
  })
  return ret
}

// SAAS-根据类型查询复核台 打包台
export const queryEquipmentForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryEquipmentWkGroupForList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 查询复核台信息单个
export const getEquipment = async (param) => {
  let ret
  await soapPost(bizTypeMap.getEquipment,param).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-根据类型查询数据字典
export const queryDataDictionaryForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryDataDictionaryGroupForList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
export const queryDiccataLogForSelect = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryDiccataLogForSelect,param).done(function (data) {
    ret = data
  })
  return ret
}
//获取数据字典明细
export const getDetails = async (param) => {
  let ret
  await soapPost(bizTypeMap.getDetails,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// SAAS-删除复核台 打包台
export const deleteEquipment = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteEquipment,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// SAAS-删除系统字典
export const deleteDataDictionary = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteDataDictionary,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-删除系统字典 明细
export const deleteDataDetails = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteDataDetails,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// SAAS-删除系统字典 新增
export const addDataDetails = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteDataDetails,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}


// SAAS-新增系统参数
export const addSystemParam = async (param) => {
  let ret
  await soapPost(bizTypeMap.addSystemParam,param,{ noParseJson: true, formatData:true}).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-查询系统参数 分页
export const querySystemParamList = async (param) => {
  let ret
  await soapPost(bizTypeMap.querySystemParamList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-删除系统参数
export const deleteSystemParam = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteSystemParam,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-修改系统参数
export const editSystemParam = async (param) => {
  let ret
  await soapPost(bizTypeMap.editSystemParam,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 获取货主信息
export const getOwners = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_getOwners, param).done(function (data) {
    ret = data
  })
  return ret
}
// 分页查询货主信息
export const qryOwnersForPageList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryOwnersForPageList, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 查询货主下发信息
export const queryOwnerByNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryOwnerByNo, param).done(function (data) {
    ret = data
  })
  return ret
}
//储位规格查询
export const qryLocationspecForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_qryLocationspecForList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

//新增储位规格
export const addLocationspec = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_addLocationspec,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

//删除储位规格
export const delLocationspec = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_delLocationspec,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}


//修改储位规格
export const  modifyLocationspec = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_modifyLocationspec,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}


// 查询商品列表
export const queryProductList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryProductList, param).done(function (data) {
    ret = data
  })
  return ret
}
// 三级品类下拉（上架策略储区锁定用，不by仓，故 withoutWarehouse）
export const qryThirdCatalogForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryThirdCatalogForList, param, { withoutWarehouse: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 查询商品列表 导出数据用
export const queryProductListAll = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryProductListAll, param).done(function (data) {
    ret = data
  })
  return ret
}

// 获取商品
export const getProduct = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_getProduct, param).done(function (data) {
    ret = data
  })
  return ret
}
// 保存商品
export const saveProduct = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_saveProduct, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 删除商品
export const deleteProduct = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_deleteProduct, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 查询条码列表
export const queryBarcodeList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryBarcodeList, param).done(function (data) {
    ret = data
  })
  return ret
}
// 添加条码
export const addBarcode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_addBarcode, param, { noParseJson: true, formatData:[param.barcode, param.ownerNo] }).done(function (data) {
    ret = data
  })
  return ret
}
// 删除条码
export const deleteBarcode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_deleteBarcode, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 获取商品储区对照
export const getGoodsZoneRef = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_getGoodsZoneRef, param, { noParseJson: true}).done(function (data) {
    ret = data
  })
  return ret
}
// 查看老品体积是否超出机区阈值并且设置了机区
export const checkGoodsVolumeIsOverThreshold = async (param) => {
  let ret
  await soapPost(bizTypeMap.checkGoodsVolumeIsOverThreshold, param, { noParseJson: true}).done(function (data) {
    ret = data
  })
  return ret
}
// 保存商品储区对照
export const saveGoodsZoneRef = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_saveGoodsZoneRef, param, { noParseJson: true,noShowError:true  }).done(function (data) {
    ret = data
  })
  return ret
}
// 批量更新商品扩展属性
export const updateItemBaseExtAttr = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_updateItemBaseExtAttr, param).done(function (data) {
    ret = data
  })
  return ret
}
// 安全库存导入
export const importSafeStock = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_importSafeStock, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 查询商品等级列表
export const queryProductLevelListForPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryProductLevelListForPage, param).done(function (data) {
    ret = data
  })
  return ret
}
// 添加商品等级
export const addProductLevel = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_addProductLevel, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 删除商品等级
export const deleteProductLevel = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_deleteProductLevel, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 获取系统配置
export const getSystemConfig = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_getSysConfigValue, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 获取单号
export const getSequence = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_getSequence, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// SAAS-删除货主
export const deleteOwners = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteOwners,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// SAAS-新增货主
export const addOwners = async (param) => {

  let ret
  await soapPost(bizTypeMap.addOwners,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 查询容器
export const queryContainer = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryContainer, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 查询rebin墙的下一个起始容器信息
export const queryNextContainer = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryNextContainer, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 查询rebin墙的下一个起始容器信息
export const modifyContainerSpecification= async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_modifyContainerSpecification, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}


// 批量生成容器
export const addContainer = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_addContainer, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

//分页查询储位
export const queryCellByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryCellByPage, param).done(function (data) {
    ret = data
  })
  return ret
}

//批量新增储位
export const batchGenarateCell = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_batchGenarateCell, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

//新模式下批量新增储位
export const batchGenarateCellNew = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_batchGenarateCellNew, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

//更新储位
export const updateLocInfo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_updateLocInfo, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//导入储位
export const importLocInfo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_importLocInfo, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

//批量删除储位
export const batchDeleteCell = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_batchDeleteCell, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//批量删除储位
export const deleteLocation = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteLocation, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//查询所有储位
export const queryCellListAll = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryCellListAll, param).done(function (data) {
    ret = data
  })
  return ret
}
// 查询供应商
export const querySupplier = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_querySuppilerByPage, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 查询承运商
export const queryCarrier = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryCarrierByPage, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 查询承运商产品
export const queryCarrierProduct = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryCarrierProductListByPage, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 新增提货分组
export const addCarrierProductGroup = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_addCarrierProductGroup, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const queryHandoverGroupList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryHandoverGroupList, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const getCarrierProductGroupSelector = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_getCarrierProductGroupSelector, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 新增承运商
export const addCarrier = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_addCarrier, param).done(function (data) {
    ret = data
  })
  return ret
}

// 删除承运商
export const deleteCarrier = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_deleteCarrier, param).done(function (data) {
    ret = data
  })
  return ret
}

// 按查询条件返回拣货顺序实体集合
export const getAislelPickupSeqForPageList = async (param) => {
  let ret
  await soapPost(bizTypeMap.getAislelPickupSeqForPageList, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 拣货顺序实体集合
export const qryAisleByZoneForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.qryAisleByZoneForList, param).done(function (data) {
    ret = data
  })
  return ret
}

// 拣货导出查询
export const exportData = async (param) => {
  let ret
  await soapPost(bizTypeMap.exportData, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 导入excel
export const importData = async (param) => {
  let ret
  await soapPost(bizTypeMap.importData, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 修改拣货信息
export const updateAisldePickupSeq = async (param) => {
  let ret
  await soapPost(bizTypeMap.updateAisldePickupSeq, param, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 删除拣货信息
export const deleteByCode = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteByCode, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

// 查询货主列表
export const queryOwnerList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryOwnerList, param).done(function (data) {
    ret = data
  })
  return ret
}

//新品维护  批量采集
export const saveMultiCollect = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_multiSaveOrUpdateItemBaseUnit, param,{noShowError:true }).done(function (data) {
    ret = data
  })
  return ret
}
//获取带电标识
export const getGoodsAttrByColumns = async (param) => {
  let ret
  await soapPost(bizTypeMap.getGoodsAttrByColumns, param).done(function (data) {
    ret = data
  })
  return ret
}

// 分页查询商品箱码信息
export const qrySkuBoxDetailsForPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qrySkuBoxDetailsForPage, param).done(function (data) {
    ret = data
  })
  return ret
}
// 商品管理-扩展属性
export const qryExpandProperties = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryExpandProperties, param).done(function (data) {
    ret = data
  })
  return ret
}
// 商品管理-保质期属性
export const qryShelflife = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryShelflife, param).done(function (data) {
    ret = data
  })
  return ret
}

// 商品管理-欧代负责人信息
export const qryResponsePersonInfoByGoodsNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryResponsePersonInfoByGoodsNo, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询储区扩展属性
export const getExtendsOfZone = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_getExtendsOfZone, param).done(function (data) {
    ret = data
  })
  return ret
}

// 按字典表查询字典明细
export const qryDicDetailByCatalog = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryDicDetailByCatalog, param).done(function (data) {
    ret = data
  })
  return ret
}
// 按字典表查询字典明细,入参不一致，可以查询不传仓号的数据
export const qryDicDetailByCatalogWithoutWarehouse = async (param,config) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryDicDetailByCatalog, param,config).done(function (data) {
    ret = data
  })
  return ret
}

// 查询储位规划信息
export const queryLocSpecPlanList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_queryLocSpecPlanList, param).done(function (data) {
    ret = data
  })
  return ret
}

// 删除储位规划信息
export const deleteLocSpecPlan = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_deleteLocSpecPlan, param).done(function (data) {
    ret = data
  })
  return ret
}
// 新增储位规划信息
export const saveLocSpecPlan = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_saveLocSpecPlan, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询个性化生产组信息
export const qryWkGrp = async (param) => {
  let ret
  await soapPost(bizTypeMap.qryWkGrp, param).done(function (data) {
    ret = data
  })
  return ret
}
// 通过复核台查询该复核台绑定的个性化生产组信息
export const getWkGrpByEquipNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.getWkGrpByEquipNo, param).done(function (data) {
    ret = data
  })
  return ret
}
// 新增或者修改工作台
export const saveEquipment = async (param) => {
  let ret
  await soapPost(bizTypeMap.saveEquipment, param).done(function (data) {
    ret = data
  })
  return ret
}
// 通过复核台查询该复核台绑定的个性化生产组信息
export const queryComplexEquipmentList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryComplexEquipmentList, param).done(function (data) {
    ret = data
  })
  return ret
}
// 保存复核台绑定的个性化生产组信息
export const addEquipWorkGroup = async (param) => {
  let ret
  await soapPost(bizTypeMap.addEquipWorkGroup, param).done(function (data) {
    ret = data
  })
  return ret
}

// 分页查询个性化生产组
export const qryWorkGroupForPagesList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_qryWorkGroupForPagesList, param).done(function (data) {
    ret = data
  })
  return ret
}

// 分页查询个性化生产组明细
export const qryWorkGroupItemForPagesList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_qryWorkGroupItemForPagesList, param).done(function (data) {
    ret = data
  })
  return ret
}
// SAAS-分页查询大区列表
export const queryZoneListForPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryZoneListForPage,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 分页查询耗材管理
export const qryConsumableitemForPagesList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryConsumableitemForPagesList, param).done(function (data) {
    ret = data
  })
  return ret
}
// 新增耗材
export const addConsumableitem = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_addConsumableitem, param).done(function (data) {
    ret = data
  })
  return ret
}
// 删除耗材
export const deleteConsumableitem = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_deleteConsumableitem, param).done(function (data) {
    ret = data
  })
  return ret
}
// 查询箱规信息
export const queryBoxRuleGroupListByCode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryBoxRuleGroupListByCode, param).done(function (data) {
    ret = data
  })
  return ret
}
// 新品采集查询箱规信息
export const queryBoxRuleGroupListByBoxBarcode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryBoxRuleGroupListByBoxBarcode, param).done(function (data) {
    ret = data
  })
  return ret
}
// 箱规和sku信息查询
export const queryGoodsNoByBoxRuleCode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryGoodsNoByBoxRuleCode, param).done(function (data) {
    ret = data
  })
  return ret
}

// 根据箱规码查询箱规详细信息
export const querySkuBoxRuleDef = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_querySkuBoxRuleDef, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryBoxRuleListByGoodsNo = async (skuBoxRuleDefQuery) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryBoxRuleListByGoodsNo, skuBoxRuleDefQuery)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 查询仓库基本信息
export const getWarehouse = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_getWarehouse, param).done(function (data) {
    ret = data
  })
  return ret
}

// 修改仓库基本信息
export const updateWarehouse = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_updateWarehouse, param).done(function (data) {
    ret = data
  })
  return ret
}

// 获取用户信息
export const getUsers = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_getUsers, param).done(function (data) {
    ret = data
  })
  return ret
}

// 货主能力配置
export const updateOwnerBusinessTag = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_updateOwnerBusinessTag, param).done(function (data) {
    ret = data
  })
  return ret
}

/**
 * 保存日志
 * @param bizName 页面路由
 * @param bizKey 方法名称
 * @param content 日志内容
 * @param cost 耗时毫秒数 单纯日志上报传0
 * @param alerm 是否触发ump自定义报警
 * @param env 所属环境 hl,xjp,gg,yn,不能是汉字
 */
export const addLog = async (param) => {
  const query = {
    ...param,
    cost: param.cost || 0
  }
  soapPost(bizTypeMap.wms_masterservice_addLog, query).done(function (data) {
    console.log(data)
  })
}

// 查询客户列表（商家列表）
export const queryCustomerList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryCustomerList, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询商家下的货主列表
export const queryOwnersByCustomerCode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryOwnersByCustomerCode, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询客户商品等级列表
export const queryOwnerProductLevelListByOwnerNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryOwnerProductLevelListByOwnerNo, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询关键节点
export const queryFirstLevelAbilityTree = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_ability_queryFirstLevelAbilityTree, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询黄金流程
export const queryAbilityTreeByParentCode = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_ability_queryAbilityTreeByParentCode, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询流程列表
export const queryModelMByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_model_queryModelMByPage, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询流程树
export const queryAbilityTree = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_ability_queryAbilityTree, param).done(function (data) {
    ret = data
  })
  return ret
}

//保存模型
export const saveModel = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_model_saveModel, param).done(function (data) {
    ret = data
  })
  return ret
}

//修改模型
export const editModel = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_model_editModel, param).done(function (data) {
    ret = data
  })
  return ret
}

// 根据模型id查询
export const queryModeByModelId = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_model_queryModeByModelId, param).done(function (data) {
    ret = data
  })
  return ret
}

// 删除模型
export const removeModel = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_model_removeModel, param).done(function (data) {
    ret = data
  })
  return ret
}

// 修改模型状态
export const editModelStatus = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_model_editModelStatus, param).done(function (data) {
    ret = data
  })
  return ret
}

// 分页查询序列号规则
export const getSkuSndestList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_getSkuSndestList, param).done(function (data) {
    ret = data
  })
  return ret
}

// 批次属性集合
export const qryLotAttributeDefForList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_qryLotAttributeDefForList, param, {withoutWarehouse: true}).done(function (data) {
    ret = data
  })
  return ret
}

// 一般补货规则配置-新增/编辑
export const saveOrUpdateReplenishmentRule = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_replenishment_saveOrUpdateReplenishmentRule, param).done(function (data) {
    ret = data
  })
  return ret
}

// 一般补货规则配置-查询规则配置列表
export const qryReplenishmentRuleByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_replenishment_qryReplenishmentRuleByPage, param).done(function (data) {
    ret = data
  })
  return ret
}

// 一般补货规则配置-删除配置
export const softDelReplenishmentRule = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_replenishment_softDelReplenishmentRule, param).done(function (data) {
    ret = data
  })
  return ret
}

// 查询所有服务商
export const queryAllCarrier = async (param) => {
  let ret
  await soapPost(bizTypeMap.query_all_carrier, param).done(function (data) {
    ret = data
  })
  return ret
}

// 货主下拉接口
export const getOwnerSelector = async (param) => {
  let queryDoc = {
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo
  }
  const paramsObj=Object.assign(queryDoc,param)
  var ret = null
  await soapPost(bizTypeMap.wms_get_owner_selector, paramsObj)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 模糊查询承运商产品
export const getCarrierProductSelector = async (param) => {
  let queryDoc = {
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo
  }
  const paramsObj=Object.assign(queryDoc,param)
  var ret = null
  await soapPost(bizTypeMap.getCarrierProductSelector, paramsObj)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 模糊查询客户
export const getCustomerSelector = async (param) => {
  let queryDoc = {
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo
  }
  const paramsObj=Object.assign(queryDoc,param)
  var ret = null
  await soapPost(bizTypeMap.getCustomerSelector, paramsObj)
    .done(function (data) {
      ret = data
    })
  return ret
}


// 号段序列号校验
export const validateSectionSerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.validateSectionSerial, param).done(function (data) {
    ret = data
  })
  return ret
}

// 模糊查询耗材
export const getConsumableSelector = async (param) => {
  let ret
  await soapPost(bizTypeMap.getConsumableSelector, param).done(function (data) {
    ret = data
  })
  return ret
}


// 商品托盘信息导入
export const importPalletInfo = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_importPalletInfo, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 机区储位类型
export const queryDistinctRobotLocTypeList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryDistinctRobotLocTypeList, param).done(function (data) {
    ret = data
  })
  return ret
}

// 批量查询商品托盘信息
export const batchQueryPalletAttr = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_batchQueryPalletAttr, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 新增月台
export const addDock = async (param) => {
  let ret
  await soapPost(bizTypeMap.addDock, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 查询机区储位列表
export const queryRobotLocTypeConfigList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryRobotLocTypeConfigList, param).done(function (data) {
    ret = data
  })
  return ret
}
// 更新月台
export const updateDock = async (param) => {
  let ret
  await soapPost(bizTypeMap.updateDock, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 保存机区储位修改数据
export const saveRobotLocTypeConfig = async (param) => {
  let ret
  await soapPost(bizTypeMap.saveRobotLocTypeConfig, param).done(function (data) {
    ret = data
  })
  return ret
}
// 删除月台
export const deleteDock = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteDock, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 批量校验唯一码校验规则batchCheckSerialIsRight
export const batchCheckSerialIsRight = async (param, callback) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_batchCheckSerialIsRight, param, {callback,noShowError: true}).done(function (data) {
    ret = data
  })
  return ret
}
// 批量导入序列号
export const importSerial = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_master_importSerial, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 查询月台
export const queryDockListByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryDockListByPage, param,).done(function (data) {
    ret = data
  })
  return ret
}
//获取月台下拉数据
export const queryDockByQuery = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryDockByQuery, param,).done(function (data) {
    ret = data
  })
  return ret
}
export const queryDockByQuerySchedule = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryDockByQuerySchedule, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 更新补货任务
export const urgentReplenishment = async (param) => {
  let ret
  await soapPost(bizTypeMap.urgentReplenishment, param,).done(function (data) {
    ret = data
  })
  return ret
}
// 批量校验唯一码校验出库标识batchCheckUniqueIsRight
export const batchCheckUniqueIsOut = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_querySerialList, param).done(function (data) {
    ret = data
  })
  return ret
}

// 获取报表自定义表头
export const queryUserConfig = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryUserConfig, param).done(function (data) {
    ret = data
  })
  return ret
}
// 保存报表自定义表头
export const saveUserConfig = async (param) => {
  let ret
  await soapPost(bizTypeMap.saveUserConfig, param).done(function (data) {
    ret = data
  })
  return ret
}
// 查询打托标准
export const getPalletInfoList = async (param) => {
  let ret
  await soapPost(bizTypeMap.getPalletInfoList, param).done(function (data) {
    ret = data
  })
  return ret
}
// 红制作图片
export const queryGoodsPictureList = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryGoodsPictureList, param).done(function (data) {
    ret = data
  })
  return ret
}
//更新图片
export const updatePalletFile = async (param) => {
  let ret
  await soapPost(bizTypeMap.updatePalletFile, param).done(function (data) {
    ret = data
  })
  return ret
}
//导入打托标准
export const importPalletInfoV2 = async (param) => {
  let ret
  await soapPost(bizTypeMap.importPalletInfoV2, param).done(function (data) {
    ret = data
  })
  return ret
}

//新增商品堆叠信息
export const insertItemBaseStack = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_insertItemBaseStack,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//查询商品堆叠信息
export const queryItemBaseShelfDTO = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryItemBaseShelfDTO,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//修改商品堆叠信息
export const updateItemBaseStack = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_updateItemBaseStack,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//删除商品堆叠信息
export const deleteItemBaseStack = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_deleteItemBaseStack,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//新增商品货架信息-填充率
export const insertItemBaseShelfSpec = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_insertItemBaseShelfSpec,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//查询商品货架信息-填充率
export const queryItemBaseShelfSpecList = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_queryItemBaseShelfSpecList,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//修改商品货架信息-填充率
export const updateItemBaseShelfSpec = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_updateItemBaseShelfSpec,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//删除商品货架信息-填充率
export const deleteItemBaseShelfSpec = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_deleteItemBaseShelfSpec,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//插入商品货架信息-填充率（批量），保留接口，目前应该用不到，新增堆叠信息的时候就新增了填充率
export const batchInsertShelfSpec = async (param) => {
  let ret
  await soapPost(bizTypeMap.wms_masterservice_batchInsertShelfSpec,param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
//SKU导出查询
export const queryItemBaseAttrCustomizeByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryItemBaseAttrCustomizeByPage,param).done(function (data) {
    ret = data
  })
  return ret
}

export const qryUsersByTaskTypeNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.qryUsersByTaskTypeNo,param).done(function (data) {
    ret = data
  })
  return ret
}
export const getCacheValue = async (param) => {
  let ret
  await soapPost(bizTypeMap.getCacheValue,param,{ noParseJson: true }).done(function (data) {
    try {
      ret = JSON.parse(data)
      return ret
    } catch (error) {
      console.log("getCacheValue try  error:" + error)
    }
    ret = data
  })
  return ret
}
export const removeCacheValue = async (param) => {
  let ret
  await soapPost(bizTypeMap.removeCacheValue,param).done(function (data) {
    ret = data
  })
  return ret
}

export const createBsLogisticsPropertyTask = async (param) => {
  let ret
  await soapPost(bizTypeMap.createBsLogisticsPropertyTask, param).done(function (data) {
    ret = data
  })
  return ret
}

export const deleteCapacity = async (param) => {
  const mergeParams=Object.assign(param,userInfoObj)
  let ret
  await soapPost(bizTypeMap.deleteCapacity, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}

export const queryCapacityByPage = async (param) => {
  const mergeParams=Object.assign(param,userInfoObj)
  let ret
  await soapPost(bizTypeMap.queryCapacityByPage, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const addCapacity = async (param) => {
  const mergeParams=Object.assign(param,userInfoObj)
  let ret
  await soapPost(bizTypeMap.addCapacity, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const modifyCapacity = async (param) => {
  const mergeParams=Object.assign(param,userInfoObj)
  let ret
  await soapPost(bizTypeMap.modifyCapacity, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const saveCalculationPeriod = async (param) => {
  let ret
  await soapPost(bizTypeMap.saveCalculationPeriod, param).done(function (data) {
    ret = data
  })
  return ret
}
export const queryWorkspaceByPage = async (param) => {
  let ret
  const mergeParams=Object.assign(param,userInfoObj)
  await soapPost(bizTypeMap.queryWorkspaceByPage, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const queryCarrierProductGroupListByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryCarrierProductGroupListByPage, param).done(function (data) {
    ret = data
  })
  return ret
}
export const addWorkspace = async (param) => {
  let ret
  const mergeParams=Object.assign(param,userInfoObj)
  await soapPost(bizTypeMap.addWorkspace, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const deleteCarrierProductGroup = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteCarrierProductGroup, param).done(function (data) {
    ret = data
  })
  return ret
}
export const modifyWorkspace = async (param) => {
  let ret
  const mergeParams=Object.assign(param,userInfoObj)
  await soapPost(bizTypeMap.modifyWorkspace, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const enableDisableCarrierProductGroup = async (param) => {
  let ret
  await soapPost(bizTypeMap.enableDisableCarrierProductGroup, param).done(function (data) {
    ret = data
  })
  return ret
}
export const enableDisableWorkspace = async (param) => {
  let ret
  const mergeParams=Object.assign(param,userInfoObj)
  await soapPost(bizTypeMap.enableDisableWorkspace, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const deleteWorkspace = async (param) => {
  let ret
  const mergeParams=Object.assign(param,userInfoObj)
  await soapPost(bizTypeMap.deleteWorkspace, mergeParams).done(function (data) {
    ret = data
  })
  return ret
}
export const querySingleCarrierProductGroup = async (param) => {
  let ret
  await soapPost(bizTypeMap.querySingleCarrierProductGroup, param).done(function (data) {
    ret = data
  })
  return ret
}
export const createCarrierProductGroup = async (param) => {
  let ret
  await soapPost(bizTypeMap.createCarrierProductGroup, param).done(function (data) {
    ret = data
  })
  return ret
}
export const queryCarrierProductListByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryCarrierProductListByPage, param).done(function (data) {
    ret = data
  })
  return ret
}
export const modifyCarrierProductGroup = async (param) => {
  let ret
  await soapPost(bizTypeMap.modifyCarrierProductGroup, param).done(function (data) {
    ret = data
  })
  return ret
}
export const getCarrierProductSelector2 = async (param) => {
  let ret
  await soapPost(bizTypeMap.getCarrierProductSelector, param||{}).done(function (data) {
    ret = data
  })
  return ret
}
export const getBarcodeList = async (param) => {
  let ret
  await soapPost(bizTypeMap.qryBarcodeList, param||{}).done(function (data) {
    ret = data
  })
  return ret
}

export const queryZoneRef = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryZoneRef, param||{}).done(function (data) {
        ret = data
  })
  return ret
}
export const batchDeleteContainer = async (param) => {
  let ret
  await soapPost(bizTypeMap.batchDeleteContainer, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
export const queryRebinWallDetail = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryRebinWallDetail, param).done(function (data) {
    ret = data
  })
  return ret
}
export const updateRebinWallContainer = async (param) => {
  let ret
  await soapPost(bizTypeMap.updateRebinWallContainer, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const queryContainerSpecificationByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryContainerSpecificationByPage, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryContainerSpecification = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryContainerSpecification, param).done(function (data) {
    ret = data
  })
  return ret
}
export const insertContainerSpecification = async (param) => {
  let ret
  await soapPost(bizTypeMap.insertContainerSpecification, param).done(function (data) {
    ret = data
  })
  return ret
}

export const updateContainerSpecification = async (param) => {
  let ret
  await soapPost(bizTypeMap.updateContainerSpecification, param).done(function (data) {
    ret = data
  })
  return ret
}

export const deleteContainerSpecification = async (param) => {
  let ret
  await soapPost(bizTypeMap.deleteContainerSpecification, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryContainerByPageV2 = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryContainerByPageV2, param).done(function (data) {
    ret = data
  })
  return ret
}
export const queryRebinWallByPage = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryRebinWallByPage, param).done(function (data) {
    ret = data
  })
  return ret
}
export const queryContainerCodeSegment = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryContainerCodeSegment, param).done(function (data) {
    ret = data
  })
  return ret
}

export const insertMultiContainerV2 = async (param) => {
  let ret
  await soapPost(bizTypeMap.insertMultiContainerV2, param,{ noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
export const queryOwnerProductLevel = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryOwnerProductLevel, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryPrintContainerCode = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryPrintContainerCode, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryContainerDistribution = async () => {
  let ret
  await soapPost(bizTypeMap.queryContainerDistribution, userInfoObj).done(function (data) {
    ret = data
  })
  return ret
}
export const queryEquipmentCode = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryEquipmentCode, userInfoObj,{ noParseJson: true }).done(function (data) {
        ret = data
  })
  return ret
}
// 任务分配/自动组波货主查询
export const getObShipmentList4OwnerNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.getObShipmentList4OwnerNo, param).done(function (data) {
    ret = data
  })
  return ret
}
// 任务分配/自动组波尾程查询
export const getObShipmentList4CarrierNo = async (param) => {
  let ret
  await soapPost(bizTypeMap.getObShipmentList4CarrierNo, param).done(function (data) {
    ret = data
  })
  return ret
}

// 按仓库编号查询仓库实体
export const queryWarehouse = async () => {
  let ret
  await soapPost(bizTypeMap.queryWarehouse,{...userInfoObj}).done(function (data) {
        ret = data
  })
  return ret
}

export const addConsumablesLocation = async (param) => {
  let ret
  await soapPost(bizTypeMap.addConsumablesLocation, param).done(function (data) {
        ret = data
  })
  return ret
}

export const querySerialRuleBySku = async (param) => {
  let ret
  await soapPost(bizTypeMap.querySerialRuleBySku, param).done(function (data) {
    ret = data
  })
  return ret
}

// 根据容器号，获取容器信息
export const getContainerDto = async (param) => {
  let ret
  await soapPost(bizTypeMap.getContainerDto, param).done(function (data) {
    ret = data
  })
  return ret
}

export const checkIfMatchTargetSerialRule = async (param) => {
  let ret
  await soapPost(bizTypeMap.checkIfMatchTargetSerialRule, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryUserLogin = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryUserLogin, param).done(function (data) {
        ret = data
  })
  return ret
}

export const fillSubSerialBySnBatch = async (param) => {
  let ret
  await soapPost(bizTypeMap.fillSubSerialBySnBatch, param,).done(function (data) {
    ret = data
  })
  return ret
}

export const scanBarcodeGetGoodsInfo = async (param) => {
  let ret
  await soapPost(bizTypeMap.scanBarcodeGetGoodsInfo, param).done(function (data) {
      ret = data
  })
  return ret
}
const countryCodesDefaultValue = [
  'BE',
  'LU',
  'FR',
  'SE',
  'DK',
  'NO',
  'US',
  'PL',
  'IT',
  'FI',
  'GB',
  'PT',
  'CZ',
  'SI',
  'NL',
  'DE',
  'AT',
  'CH',
  'EU',
  'TH',
  'VN',
  'ES',
  'JP',
  'KR'
]

export const getAllCountryCodes = async (needAll = false) => {
  let ret
  try{
    await soapPost(bizTypeMap.getAllCountryCodes, {}).done(function (data) {
      ret = data
    })
  }catch(e){
    console.log(e)
  }
  if(Array.isArray(ret) && ret.length > 0){
    ret = ret.sort()
  }else{
     ret = countryCodesDefaultValue.sort()
  }
  if(needAll) ret.unshift('ALL')
  return ret
}

export const checkIfMatchTargetSerialRuleAndExistedBatch4Reverse = async (param) => {
  let ret
  await soapPost(bizTypeMap.checkIfMatchTargetSerialRuleAndExistedBatch4Reverse, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryAssistant = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryAssistant, param).done(function (data) {
    ret = data
  })
  return ret
}

export const bindAssistant = async (param) => {
  let ret
  await soapPost(bizTypeMap.bindAssistant, param).done(function (data) {
    ret = data
  })
  return ret
}

export const unbindAssistant = async (param) => {
  let ret
  await soapPost(bizTypeMap.unbindAssistant, param).done(function (data) {
    ret = data
  })
  return ret
}

export const flexibleReportQuery = async (param) => {
  let ret
  await soapPost(bizTypeMap.flexibleReportQuery, param).done(function (data) {
    ret = data
  })
  return ret
}

export const checkBindAssistant = async (param) => {
  let ret
  await soapPost(bizTypeMap.checkBindAssistant, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryContainerTransferTaskDetail = async (param) => {
  let ret
  await soapPost(bizTypeMap.queryContainerTransferTaskDetail, param).done(function (data) {
    ret = data
  })
  return ret
}

export const queryAssistantByAssistantUserAccount = async (callback) => {
  let ret
  let canCallback = true
  try{
    await soapPost(bizTypeMap.queryAssistantByAssistantUserAccount, {
       assistantUserAccount: userInfo.userCode
    },{noShowError: true}).done(function (data) {
      ret = data
      if(['100101510', '100101511'].includes(ret.resultCode)){
        let arr = []
        try{
          arr = JSON.parse(ret.resultValue)
        }catch(e){
          console.log(e)
        }
        canCallback = false
        MessageBox.confirm(i18n.t(ret.resultCode, arr), i18n.t('prompt'), {
            confirmButtonText: i18n.t('yes'),
            cancelButtonText: i18n.t('no'),
            showClose: false,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            unbindAssistant({
              userAccount: arr[1],
              employeeNo:  userInfo.userCode
            })
            .then(res => {
              $notify.success(i18n.t('operateSuccess'));
            })
            .finally(() => {
               callback && callback()
            })
          }).catch(() => { });
      }else if(ret.resultCode){
        customizeNotifyWithVoiceFormat(NOTIFY_TYPE_ENUM.error, i18n.t(ret.resultCode))
      }else{
  
      }
    })
  }finally{
    if(canCallback) callback && callback()
  }
}



